import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)``;

export const ContentSection = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 20px;
  z-index: 2;
  width: 100%;
  max-width: 500px;
  padding: 0 16px;
  align-items: center;
`;

export const LogoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;

  .dialogue-text {
    color: #fff;
    text-align: center;
    margin: 0;
  }
`;

export const StoresLinks = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  max-width: 380px;

  a {
    display: block;
    aspect-ratio: 1 / 0.29;
    width: 166px;
    font-size: 0;
    line-height: 0;

    @media screen and (min-width: 576px) {
      width: 168px;
    }

    img {
      height: 100%;
      width: 100%;
    }
  }
`;
